export default "__VITE_ASSET__Cv$curD2__"